import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { genres } from "@/mocks/genres";

const stats = [
  { value: "5+", label: "核心题材分类" },
  { value: "22+", label: "精选连载作品" },
  { value: "9.0+", label: "读者平均评分" },
  { value: "24h", label: "每日更新同步" },
];

const principles = [
  {
    icon: "ri-scissors-line",
    title: "分类即效率",
    desc: "以题材为核心做精细切分，让读者按口味直达目标，而不是在海量内容里大海捞针。",
  },
  {
    icon: "ri-star-smile-line",
    title: "评分即口碑",
    desc: "以真实的评分与人气数据呈现作品价值，帮助每一位读者快速判断是否值得入坑。",
  },
  {
    icon: "ri-refresh-line",
    title: "更新即活力",
    desc: "持续跟进连载进度与最新话更新，让追更成为一件省心又轻松的事。",
  },
  {
    icon: "ri-shield-check-line",
    title: "内容即责任",
    desc: "认真对待每一部作品的分类、简介与信息展示，维护健康、有序的阅读环境。",
  },
];

const reviews = [
  {
    name: "小鹿爱吃糖",
    role: "校园漫爱好者",
    content: "分类做得很细，找校园恋漫再也不用来回乱翻，按分类进去基本都能找到想看的，体验很顺。",
  },
  {
    name: "青空一页",
    role: "悬疑推理迷",
    content: "悬疑分类的推荐质量很高，评分也很真实，跟着人气榜追了好几部《第七个房间》《无声证词》，都很好看。",
  },
  {
    name: "木棉",
    role: "奇幻题材老书虫",
    content: "更新跟得很及时，最新话一出来首页就能看到，追更体验很舒服，编辑精选也经常能挖到宝藏。",
  },
];

export default function About() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main>
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

        <section className="relative overflow-hidden bg-gradient-to-br from-primary-500 to-accent-500">
          <div className="container-x py-14 text-center md:py-20">
            <p className="mb-3 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
              <i className="ri-heart-3-fill text-secondary-300" /> 关于 91韩漫画
            </p>
            <h1 className="font-heading text-3xl font-bold text-background-50 md:text-4xl">
              为热爱韩漫的你，做一架省心的分类索引
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
              91韩漫画专注于校园、奇幻、都市、恋爱、悬疑等题材的韩漫分类与内容导航，
              用清晰的结构和真实的口碑数据，让你想看特定类型的韩漫时，直接进分类就能找到。
            </p>
          </div>
        </section>

        <section className="container-x -mt-8">
          <div className="grid grid-cols-2 gap-4 rounded-lg border border-background-200 bg-background-50 p-6 shadow-soft md:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="text-center">
                <p className="font-heading text-3xl font-bold text-primary-600">{s.value}</p>
                <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="container-x py-12 md:py-16">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            我们的定位与理念
          </h2>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            我们相信，好的阅读体验始于"找得对、找得快"。91韩漫画以题材分类为骨架，以评分、人气与更新状态为血肉，
            把最热门的剧情韩漫整理成一张清晰的地图。无论是校园里的小悸动、奇幻世界的大冒险，
            还是都市霓虹下的都市异闻、悬疑迷雾中的层层真相，你都能沿着分类，一步抵达想看的作品。
          </p>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            我们坚持真实：评分来自读者的实际阅读反馈，人气来自真实的浏览数据，更新进度保持与连载同步。
            不堆砌、不夸大，只为让每一次点击都物有所值。
          </p>
        </section>

        <section className="section-pad bg-background-100">
          <div className="container-x">
            <h2 className="mb-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              我们的内容原则
            </h2>
            <p className="mb-6 text-sm text-foreground-600">
              把"分类准、口碑真、更新快、责任稳"落实到每一处细节。
            </p>
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                    <i className={p.icon} />
                  </span>
                  <h3 className="mt-4 text-base font-semibold text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="container-x py-12 md:py-16">
          <h2 className="mb-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            读者怎么说
          </h2>
          <p className="mb-6 text-sm text-foreground-600">来自真实读者的口碑，是我们坚持的动力。</p>
          <div className="grid gap-4 md:grid-cols-3">
            {reviews.map((r) => (
              <figure
                key={r.name}
                className="rounded-lg border border-background-200 bg-background-50 p-6"
              >
                <div className="flex gap-0.5 text-secondary-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{r.content}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-sm font-bold text-secondary-900">
                    {r.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{r.name}</p>
                    <p className="text-xs text-foreground-500">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        <section className="section-pad bg-background-100">
          <div className="container-x">
            <h2 className="mb-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              联系我们
            </h2>
            <p className="mb-6 text-sm text-foreground-600">反馈建议、投稿合作，欢迎随时与我们取得联系。</p>
            <div className="grid gap-4 md:grid-cols-3">
              <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                  <i className="ri-mail-line" />
                </span>
                <div>
                  <p className="text-xs text-foreground-500">服务邮箱</p>
                  <a href="mailto:service@91hanmanhua.com" className="text-sm font-medium text-foreground-950 hover:text-primary-600">
                    service@91hanmanhua.com
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xl text-accent-700">
                  <i className="ri-message-2-line" />
                </span>
                <div>
                  <p className="text-xs text-foreground-500">投稿合作</p>
                  <a href="mailto:editor@91hanmanhua.com" className="text-sm font-medium text-foreground-950 hover:text-primary-600">
                    editor@91hanmanhua.com
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-800">
                  <i className="ri-shape-2-line" />
                </span>
                <div>
                  <p className="text-xs text-foreground-500">题材导航</p>
                  <p className="text-sm font-medium text-foreground-950">
                    {genres.map((g) => g.name).join(" · ")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}